import { StaffClass } from "../../staff/models/staff";

export const StructureContentSections =  {
    role: "Competenze",
    staff: "Componenti",
    contacts: "Contatti",
    documents: "Documenti",
    more_info: "Ulteriori informazioni"
}

export class StructureClass {    
  
    constructor(data){
        this.id = data.id;
        this.name = data.name;
        this.slug = data.slug;
        this.content = data.content;
        this.last_update = data.last_update;
        this.staff = data.staff_data?.map((staff) => new StaffClass(staff)) || [];
    }
}

